module.exports = __webpack_public_path__ + "img/Text with image-button-title.03d684fd.svg";